export default __webpack_public_path__ + "static/media/akc-logo.420a1451.svg";